import React from 'react';
import { createRoot } from 'react-dom/client';
import { NexusReactRoot } from './app/NexusReactRoot';
import { isFeatureEnabled, setFeatureOverride, clearFeatureOverride, featureFlags } from './utils/featureFlags';
import * as NexusComponents from './components';
import * as NexusHooks from './hooks';
import * as ReservationAdapters from './utils/reservationAdapter';
import * as ReservationSelectors from './utils/reservationSelectors';
import { queryClient } from './app/queryClient';
import { useSessionStore } from './state/useSessionStore';

const mountedRoots = new Map();

function mountRoot(targetId = 'nexus-react-root') {
  const target = document.getElementById(targetId);
  if (!target || mountedRoots.has(targetId)) return null;
  const root = createRoot(target);
  root.render(<NexusReactRoot />);
  mountedRoots.set(targetId, root);
  return root;
}

function unmountRoot(targetId = 'nexus-react-root') {
  const root = mountedRoots.get(targetId);
  if (!root) return false;
  root.unmount();
  mountedRoots.delete(targetId);
  return true;
}

window.NexusReact = {
  mountRoot,
  unmountRoot,
  isFeatureEnabled,
  setFeatureOverride,
  clearFeatureOverride,
  featureFlags,
  components: NexusComponents,
  hooks: NexusHooks,
  adapters: { ...ReservationAdapters, selectors: ReservationSelectors },
  queryClient,
  useSessionStore
};

document.addEventListener('DOMContentLoaded', () => {
  mountRoot();
});
